import type {
  Input,
  RefName,
  UpdateNodeBody,
} from "@/workflow_api/types/workflow";
import { mapNodeTypeToRefName } from "../node-type-mapping";
import { getNodeTypeLabel } from "../node-type-selector";
import type { MergeNodeConfig, MergeNodeData } from "../types";
import type { MergeEdge } from "./edges";

export const serializeMergeNode = (config: MergeNodeConfig): MergeNodeData => {
  return {
    nodeType: config.merge_node_type,
    entries: config.entries,
    manualConfirmation: config.manual_continue,
    connections: {
      default: {
        display_name: "Salida",
        target_node: null,
      },
    },
  };
};

export const deserializeMergeNode = (data: MergeNodeData): MergeNodeConfig => {
  return {
    merge_node_type: data.nodeType,
    entries: data.entries,
    manual_continue: data.manualConfirmation,
  };
};

export const getSerializedMergeInputs = (config: MergeNodeConfig): Input => {
  const inputs: Input = [];

  inputs.push({
    name: "merge_node_type",
    value: mapNodeTypeToRefName(config.merge_node_type),
    type: "STRING",
  });

  config.entries.forEach((entry, index) => {
    inputs.push({
      name: `entry_${index + 1}`,
      type: "MERGE_ENTRY",
      value: JSON.stringify({
        name: entry.name,
        node_id: entry.nodeId,
      }),
    });
  });

  return inputs;
};

export const mergeNodeToApiFormat = (
  config: MergeNodeConfig,
  flowId: string,
  order: number,
  position: { x: number; y: number },
): UpdateNodeBody & { edges?: MergeEdge[] } => {
  return {
    flow_id: flowId,
    ref_name: "merge-node" as RefName,
    display_name:
      config.display_name ||
      `Merge_${getNodeTypeLabel(config.merge_node_type)}`,
    order: order,
    position_x: position.x,
    position_y: position.y,
    type: "MERGE",
    manual_continue: config.manual_continue,
    inputs: getSerializedMergeInputs(config),
  };
};
